// 保存任务独立于编辑器实例；离开路由后仍提交已捕获的快照。
export function createDraftSaveQueue ({ write, scope = () => '' }) {
  const entries = new Map()
  const key = id => JSON.stringify([scope(), id])
  // 界面观察者的异常不能中断实际写入或误报服务器保存失败。
  const notify = (entry, listener) => { try { listener(entry) } catch (error) { /* 观察者不属于保存事务。 */ } }
  const emit = entry => entry.listeners.forEach(listener => notify(entry, listener))
  const finish = (job, value) => job.waiters.forEach(resolve => resolve(value))
  async function run (entry) {
    while (entry.jobs.length) {
      const job = entry.jobs.shift()
      entry.active = job; entry.error = ''; emit(entry)
      try {
        if (entry.scope !== scope()) throw new Error('登录状态已变化，请重新打开项目后保存')
        const saved = await write(job.snapshot, entry.status)
        if (saved.record.metadata !== job.snapshot.metadata) throw new Error('保存结果与本次提交不一致，请保留编辑内容并重新加载检查')
        entry.record = saved.record; entry.status = saved.status; entry.savedSignature = job.snapshot.signature
        entry.result = { ...saved, signature: job.snapshot.signature }
        entry.active = null; emit(entry); finish(job, entry.result)
      } catch (error) {
        entry.error = error.message || '后台保存失败，请重试'
        entry.active = null
        finish(job, false); entry.jobs.forEach(pending => finish(pending, false)); entry.jobs = []
        emit(entry); break
      }
    }
    entry.running = false; emit(entry)
  }
  function enqueue (snapshot) {
    const id = key(snapshot.record.id)
    let entry = entries.get(id)
    if (!entry) {
      entry = { scope: scope(), record: snapshot.record, status: snapshot.status, savedSignature: snapshot.baselineSignature, result: null, latest: null, active: null, jobs: [], listeners: new Set(), running: false, error: '' }
      entries.set(id, entry)
    } else if (!entry.running && !entry.active && !entry.jobs.length && !entry.error) {
      entry.record = snapshot.record; entry.status = snapshot.status; entry.savedSignature = snapshot.baselineSignature
      entry.result = null
    }
    const same = job => job && job.snapshot.metadata === snapshot.metadata && job.snapshot.versionName === snapshot.versionName && (snapshot.versionName === undefined || job.snapshot.pageId === snapshot.pageId)
    const last = entry.jobs[entry.jobs.length - 1] || entry.active
    return new Promise(resolve => {
      if (same(last)) { last.waiters.push(resolve); return }
      const job = { snapshot, waiters: [resolve] }
      const tail = entry.jobs[entry.jobs.length - 1]
      // 自动保存只保留最新待提交快照；命名历史需要逐条保留。
      if (tail && tail.snapshot.versionName === undefined && snapshot.versionName === undefined) {
        job.waiters.push(...tail.waiters); entry.jobs[entry.jobs.length - 1] = job
      } else entry.jobs.push(job)
      entry.latest = snapshot; entry.error = ''; emit(entry)
      if (!entry.running) { entry.running = true; run(entry) }
    })
  }
  function observe (id, listener) {
    const entry = entries.get(key(id))
    if (!entry) return () => {}
    entry.listeners.add(listener); notify(entry, listener)
    return () => entry.listeners.delete(listener)
  }
  function read (id, serverStatus) {
    const entry = entries.get(key(id))
    if (!entry || !entry.latest) return null
    if (serverStatus && !entry.running && !entry.error && (serverStatus.revision > entry.status.revision || (serverStatus.revision === entry.status.revision && serverStatus.checksum !== entry.status.checksum))) return null
    return entry.running || entry.error || (serverStatus && entry.status.revision > serverStatus.revision) ? entry : null
  }
  return { enqueue, observe, read }
}
